import React from 'react'
import { FilterSection } from './FilterSection'

export function FiltersSidebar({ 
  filterOptions, 
  selectedFilters, 
  onFilterToggle, 
  onClearAll 
}) {
  const formatCategoryName = (category) => {
    return category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  return (
    <div className="data-explorer__sidebar">
      <div className="data-explorer__filters">
        <div className="filters-header">
          <h3>Filters</h3>
          <button 
            className="clear-filters"
            onClick={onClearAll}
          >
            Clear all
          </button>
        </div>
        
        <div className="scrollable">
          <div className="scrollable__content">
            {filterOptions && Object.entries(filterOptions).map(([category, options]) => (
              <FilterSection
                key={category}
                title={formatCategoryName(category)}
                options={options}
                selectedOptions={selectedFilters[category] || []}
                onToggle={(option) => onFilterToggle(category, option)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

